"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gisFileTypesMap = exports.gisFileTypes = exports.gisFileStatuses = exports.gisFileStatusKeys = exports.gisClientFileTypes = exports.geodataAnalysisStatuses = exports.GeodataAnalysis = exports.GISFile = void 0;
var _colors = require("@mui/material/colors");
const gisFileStatusKeys = exports.gisFileStatusKeys = ['toDo', 'doing', 'standby', 'done'];
const gisClientFileTypes = exports.gisClientFileTypes = ['CLIENT_ANALYSIS_DOCUMENT', 'CLIENT_INTEGRATION_DOCUMENT'];
const gisFileTypes = exports.gisFileTypes = [...gisClientFileTypes, 'ANALYSIS_GUIDELINE', 'ANALYSIS_REPORT', 'INTEGRATION_REPORT'];
class GISFile {
  constructor(id, title, comment, documentUrl, status, created, creatorId, messages, type, geodataAnalysis) {
    this.id = id;
    this.title = title;
    this.comment = comment;
    this.documentUrl = documentUrl;
    this.status = status;
    this.created = created;
    this.creatorId = creatorId;
    this.messages = messages;
    this.type = type;
    this.geodataAnalysis = geodataAnalysis;
  }
}
exports.GISFile = GISFile;
const gisFileStatuses = exports.gisFileStatuses = {
  toDo: {
    titleKey: 'commons.gis_file_statuses.to_do',
    color: _colors.deepOrange[500]
  },
  doing: {
    titleKey: 'commons.gis_file_statuses.doing',
    color: _colors.blue[500]
  },
  standby: {
    titleKey: 'commons.gis_file_statuses.standby',
    color: _colors.orange[500]
  },
  done: {
    titleKey: 'commons.gis_file_statuses.done',
    color: _colors.green[500]
  }
};
const gisFileTypesMap = exports.gisFileTypesMap = {
  ANALYSIS_GUIDELINE: {
    titleKey: 'commons.gis_file_types.analysis_guideline'
  },
  ANALYSIS_REPORT: {
    titleKey: 'commons.gis_file_types.analysis_report'
  },
  CLIENT_ANALYSIS_DOCUMENT: {
    titleKey: 'commons.gis_file_types.client_analysis_document'
  },
  INTEGRATION_REPORT: {
    titleKey: 'commons.gis_file_types.integration_report'
  },
  CLIENT_INTEGRATION_DOCUMENT: {
    titleKey: 'commons.gis_file_types.client_integration_document'
  }
};
class GeodataAnalysis {
  constructor(id, title, description, status, created, updated) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.status = status;
    this.created = created;
    this.updated = updated;
  }
}
exports.GeodataAnalysis = GeodataAnalysis;
const geodataAnalysisStatuses = exports.geodataAnalysisStatuses = {
  WRITING_GUIDELINES: {
    titleKey: 'commons.gis_file_statuses.writing_guidelines',
    color: _colors.blue[500]
  },
  WAITING_CLIENT_VALIDATION: {
    titleKey: 'commons.gis_file_statuses.waiting_client_validation',
    color: _colors.orange[500]
  },
  VALIDATED_GUIDELINES: {
    titleKey: 'commons.gis_file_statuses.validated_guideline',
    color: _colors.orange[500]
  },
  ABANDONED: {
    titleKey: 'commons.gis_file_statuses.adandoned',
    color: _colors.red[500]
  },
  WAITING_CLIENT_DATA: {
    titleKey: 'commons.gis_file_statuses.waiting_client_data',
    color: _colors.orange[500]
  },
  ONGOING: {
    titleKey: 'commons.gis_file_statuses.ongoing',
    color: _colors.blue[500]
  },
  DONE: {
    titleKey: 'commons.gis_file_statuses.done',
    color: _colors.green[500]
  }
};